import { FC, useMemo } from 'react'
import { Grid, Stack, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import { CreativeUploadWizardStep } from './_main/CreativeUploadWizard.controller'
import { DynamicFlowStep } from '../DynamicFlow'
import { FileAPIUpload } from '../FileAPIUpload'
import { ImageItem } from './ImageItem.comonent'
import { SectionedBorderBox } from '../SectionedBorderBox'
import { SystemMessage } from '../SystemMessage'
import { useCreativeUploadWizard } from './_main/CreativeUploadWizard.context'

/** Dynamic flow step for additional visual upload */
export const AdditionalVisualsStep: FC = () => {
  const { t } = useTranslation(['ct_upload_wizard'])
  const { fileCtrl } = useCreativeUploadWizard()

  const filesToDisplay = useMemo(() => fileCtrl.filesByTag[CreativeUploadWizardStep.ADDITIONAL_VISUALS] ?? [], [fileCtrl.filesByTag])

  return (
    <DynamicFlowStep
      stepKey={CreativeUploadWizardStep.ADDITIONAL_VISUALS}
      isValid={true}
    >
      <Stack alignItems="center" gap={3} p="4rem 0">

        <Typography
          variant="h2"
          textAlign="left"
          width="90%"
          fontWeight={600}
          maxWidth="100rem"
          lineHeight="normal"
        >
          {t('additional_step.title')}
        </Typography>

        <SystemMessage
          sx={{ width: '90%', maxWidth: '100rem' }}
          message={(
            <Typography fontSize="1.4rem" component="span">
              <Trans
                t={t}
                i18nKey="additional_step.info_message"
                components={{
                  list: <ul style={{ padding: '0 2rem' }} />,
                  item: <li />,
                }}
              >
                &nbsp;
              </Trans>
            </Typography>
          )}
        />

        <SectionedBorderBox
          width="90%"
          maxWidth="100rem"
          title={
            <Typography variant="h3" fontWeight={500} lineHeight="normal" mb=".5rem">
              {t('additional_step.upload_title')}
            </Typography>
          }
          position="relative"
          p={2}
        >
          <Stack gap={2}>

            <FileAPIUpload
              showFileListing={false}
              acceptedFileTypes="any"
              files={filesToDisplay}
              uploadHandler={(acceptedFiles) => fileCtrl.uploadFiles(acceptedFiles, {
                tag: CreativeUploadWizardStep.ADDITIONAL_VISUALS,
                onSettled: (successIds) => {
                  fileCtrl.loadFiles(successIds)
                },
              })}
            />

            <Grid container spacing={1}>
              {!!filesToDisplay.length && filesToDisplay.sort((fileA, fileB) => fileB.order - fileA.order).map((file) => (
                <Grid item key={file.id} xs={3}>
                  <ImageItem file={file} fileCtrl={fileCtrl} config={{ allowDelete: true }} />
                </Grid>
              ))}
            </Grid>

          </Stack>
        </SectionedBorderBox>

      </Stack>
    </DynamicFlowStep>
  )
}
